export const LS_DEVICE_ID_KEY = "generated-device-id";

export function getDeviceId() {
  let deviceId = localStorage.getItem(LS_DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(LS_DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}
